function openSearch() {

    if ($(window).width() >= 992) {
        $('#search-popup-conteiner').css('display', 'flex');
        showSearchOverlay();
    }
    if ($(window).width() <= 992) {
        $('.search-popup-conteiner-mobile').css('display', 'block');
        showSearchOverlay();
    }

}

function closeSearch() {
    if ($(window).width() >= 992) {
        $('#search-popup-conteiner').css('display', 'none');
    } else {
        $('.search-popup-conteiner-mobile').css('display', 'none');
    }
}

function showSearchOverlay() {
    $('.search-overlay').css('display', 'block');
}

function hideSearchOverlay() {
    $('.search-overlay').css('display', 'none');
}


function delay(callback, ms) {
    var timer = 0;
    return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}


$(document).ready(function () {
    $("#search_query_block").click(function () {
        showSearchOverlay();
        if (this.value.length > 2) {
            getSuggestions(this.value);
        }

    });


    $("#search_input_mobile").click(function () {
        showSearchOverlay();
    });
    $(".remove-search-input-val").click(function () {
        $('#search_query_block').val('');
        $(".remove-search-input-val").hide();
        $('#search_query_block').focus();
    });
    $(".remove-search-input-val-mobile").click(function () {
        $('#search_input_mobile').val('');
        $(".remove-search-input-val-mobile").hide();
    });


    if ($("#search_query_block").length) {
        var input = document.getElementById("search_query_block");
        input.addEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                $("#searchbox").submit();
            }
        });
    }

    $(".search-popup").click(function () {
        $("#search_query_block").focus();
    });

    $(".search-popup-conteiner-mobile").click(function () {
        $("#search_input_mobile").focus();
    });

    $(".submitSearch").click(function () {
        var search_input_mobile_val = $('#search_input_mobile').val();
        if (search_input_mobile_val) {
            window.location.replace($('#searchbox').attr('action') + '?p=' + search_input_mobile_val);
        }
    });

    if ($("#search_input_mobile").length) {
        var input = document.getElementById("search_input_mobile");
        input.addEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                var search_input_mobile_val = $('#search_input_mobile').val();
                if (search_input_mobile_val) {
                    window.location.replace($('#searchbox').attr('action') + '?p=' + search_input_mobile_val);
                }
            }
        });
    }


    $('body').on('click', '.customUrl', function (event) {
        event.preventDefault();

        var url = jQuery(this).attr('href');
        document.location = url;


    });

    $("body").click(function () {
        if (!$("#search_query_block").is(":focus") && !$("#search_input_mobile").is(":focus")) {
            hideSearchOverlay();
            closeSearch();
        }
    });


});


$(document).ready(function () {
    $("#search_query_block").keyup(delay(function (e) {

        if (this.value.length > 2) {
            getSuggestions(this.value);
            $('.remove-search-input-val').show();
        } else {
            closeSearch();
            $('.remove-search-input-val').hide();
        }

    }, 300));


    $("#search_input_mobile").keyup(delay(function (e) {

        if (this.value.length > 2) {
            $('.remove-search-input-val-mobile').show();
            getSuggestions(this.value);
        } else {
            $('.remove-search-input-val-mobile').hide();
            closeSearch();
        }

    }, 300));

});


function getSuggestions(keywords) {


    var settings = {
        "url": `https://api.lupasearch.com/v1/query/${suggestions_query_key}`,
        "method": "POST",
        "timeout": 0,
        "headers": {
            "Content-Type": "application/json"
        },
        "data": JSON.stringify({"searchText": keywords, "limit": 5}),
    };

    $.ajax(settings).done(function (response) {
        if (response.length > 0) {
            getCategory(keywords, response);
        } else {
            getCategory(keywords, null);
        }
    });

}

function getCategory(keywords, suggestions) {
    var settings = {
        "url": `https://api.lupasearch.com/v1/query/${category_query_key}`,
        "method": "POST",
        "timeout": 0,
        "headers": {
            "Content-type": "application/json"
        },
        "data": JSON.stringify({"searchText": keywords, "limit": 3}),
    };

    var returns = {};

    $.ajax(settings).done(function (response) {

        if (response.total < 1) {
            getProductTypeCategory(keywords, suggestions, null);
        } else {
            getProductTypeCategory(keywords, suggestions, response.items);
        }

    });

}

function getProductTypeCategory(keywords, suggestions, category) {
    var settings = {
        "url": `https://api.lupasearch.com/v1/query/${product_type_category_query_key}`,
        "method": "POST",
        "timeout": 0,
        "headers": {
            "Content-type": "application/json"
        },
        "data": JSON.stringify({"searchText": keywords, "limit": 3}),
    };

    $.ajax(settings).done(function (response) {

        if (response.total < 1) {
            getProducts(keywords, suggestions, category, null);
        } else {
            getProducts(keywords, suggestions, category, response.items);
        }

    });

}


function getProducts(keywords, suggestions, category, productType) {

    var settings = {
        "url": `https://api.lupasearch.com/v1/query/${product_key_not_group}`,
        "method": "POST",
        "timeout": 0,
        "headers": {
            "Content-type": "application/json"
        },
        "data": JSON.stringify({"searchText": keywords, "limit": 4}),
    };


    $.ajax(settings).done(function (response) {

        if (response.total < 1) {
            formatRezults(suggestions, null, category, productType, null);
        } else {
            let brand = null
            response.facets.map(facet => {
                if (facet.key == 'brand') {
                    brand = facet.items
                }
            })
            formatRezults(suggestions, brand, category, productType, response);
        }

    });

}


function formatRezults(suggestions, brand, category, productType, product_response) {


    var formAction = $("#searchbox").attr('action');
    if ($(window).width() >= 992) {
        var inputValue = $('#search_query_block').val();
    } else {
        var inputValue = $('#search_input_mobile').val();
    }

    var returnValueProduct = '';
    var returnValueSuggestions = '';

    if (product_response != null) {
        var product = product_response.items
        $(product).each(function (index, element) {
            returnValueProduct += '<a href="' + element.url + '"><div class="search-product-list-item"><div class="search-product-list-img"><img src="' + element.image + '"></div><div class="search-product-list-text"> ' + element.title + '</div></div></a>';
        });

        if (returnValueProduct) {
            returnValueProduct = '<h3>' + product_text + '<a href="' + formAction + '?p=' + inputValue.replace("'", '') + '" class="all-product">' + all_product_text + '</a></h3> ' + returnValueProduct;
        }
    }

    var findvalue = [];
    if (brand != null) {

        var returnValueBrand = '';

        var i = 1;
        $(brand).each(function (index, element) {
            if (element.title !== 'KlipShop') {
                if (i++ <= 4) {
                    var encodedUrl = encodeURIComponent(base64EncodeUnicode(element.title));

                    if ($(window).width() >= 992) {
                        returnValueBrand += "<li><a class='customUrl' href='" + formAction + '?p=' + encodeURIComponent(element.title.replace(/'/g, "")) + "&brand_" + encodedUrl + "=" + encodedUrl + "'>" + element.title + "</a></li>";
                    } else {
                        returnValueBrand += "<div class='mobile-item'><a class='customUrl' href='" + formAction + '?p=' + encodeURIComponent(element.title.replace(/'/g, "")) + "&brand_" + encodedUrl + "=" + encodedUrl + "'>" + element.title + "</a></div>";
                    }
                    findvalue.push(element.title.toLowerCase());
                }
            }
        });

        if (returnValueBrand) {
            var returnValueBrandHtml = '<h3>' + brand_text + '</h3><ul>' + returnValueBrand + '</ul>';
        }
        if ($(window).width() >= 992) {
            $('.brand-list').html(returnValueBrandHtml);
            $('.brand-list').css('display', 'block');
        } else {
            $('#brand-list-mobile').html(returnValueBrandHtml);
            $('#brand-list-mobile').css('display', 'block');
        }
    } else {
        if ($(window).width() >= 992) {
            $('.brand-list').css('display', 'none');
        } else {
            $('#brand-list-mobile').css('display', 'none');
        }
    }


    if (category != null || productType != null) {

        var returnValueCategory = '';
        if (category != null) {
            $(category).each(function (index, element) {

                findvalue.push(element.name.toLowerCase());

                if ($(window).width() >= 992) {
                    returnValueCategory += "<li><a href='" + element.url + "'>" + element.name + "</a></li>";
                } else {
                    returnValueCategory += "<div class='mobile-item'><a href='" + element.url + "'>" + element.name + "</a></div>";
                }
            });
        }

        if (productType != null) {
            $(productType).each(function (index, element) {
                findvalue.push(element.name.toLowerCase());
                if ($(window).width() >= 992) {
                    returnValueCategory += "<li><a href='" + element.url + "'>" + element.name + "</a></li>";
                } else {
                    returnValueCategory += "<div class='mobile-item'><a href='" + element.url + "'>" + element.name + "</a></div>";
                }

            });
        }

        if (returnValueCategory) {
            if ($(window).width() >= 992) {
                var returnValueCategoryHtml = '<h3>' + category_text + '</h3><ul>' + returnValueCategory + '</ul>';
            } else {
                var returnValueCategoryHtml = '<h3>' + category_text + '</h3>' + returnValueCategory;
            }
        }

        if ($(window).width() >= 992) {
            $('.category-list').html(returnValueCategoryHtml);
            $('.category-list').css('display', 'block');
        } else {
            $('#category-list-mobile').html(returnValueCategoryHtml);
            $('#category-list-mobile').css('display', 'block');
        }


    } else {
        if ($(window).width() >= 992) {
            $('.category-list').css('display', 'none');
        } else {
            $('#category-list-mobile').css('display', 'block');
        }
    }

    $(suggestions).each(function (index, element) {
        if (inputValue.toLowerCase() != element.suggestion.toLowerCase() && jQuery.inArray(element.suggestion, findvalue) === -1) {

            if ($(window).width() >= 992) {
                returnValueSuggestions += "<span><a href='" + formAction + "?p=" + element.suggestion.replace("'", '') + "'>" + element.suggestion + "</a></span>";
            } else {
                returnValueSuggestions += "<div class='mobile-item'><a href='" + formAction + "?p=" + element.suggestion.replace("'", '') + "'>" + element.suggestion + "</a></div>";
            }
        }
    });

    if (returnValueSuggestions) {
        returnValueSuggestions = '<h3>' + suggestions_text + '</h3>' + returnValueSuggestions;
    }

    if ($(window).width() >= 992) {
        if (returnValueSuggestions) {
            $('.did-you-mean').html(returnValueSuggestions);
            $('.did-you-mean').css('display', 'block');
        } else {
            $('.did-you-mean').css('display', 'none');
        }
    } else {
        if (returnValueSuggestions) {
            $('#did-you-mean-mobile').html(returnValueSuggestions);
            $('#did-you-mean-mobile').css('display', 'block');
        } else {
            $('#did-you-mean-mobile').css('display', 'none');
        }
    }
    if ($(window).width() >= 992) {
        if (returnValueProduct) {
            $('.search-product-list').html(returnValueProduct);
            $('.search-product-list').css('display', 'block');
        } else {
            $('.search-product-list').css('display', 'none');
        }
    } else {
        if (returnValueProduct) {
            $('#search-product-list-mobile').html(returnValueProduct);
            $('#search-product-list-mobile').css('display', 'block');
        } else {
            $('#search-product-list-mobile').css('display', 'none');
        }
    }

    if (returnValueSuggestions == '' && returnValueProduct == '') {
        closeSearch();
    } else {
        openSearch();
    }

}


function base64EncodeUnicode(str) {

    var utf8Str = unescape(encodeURIComponent(str));
    // Use btoa to base64 encode the UTF-8 byte array
    return btoa(utf8Str);
}




